export default "__VITE_ASSET__B4pCh0xs__";